export default __webpack_public_path__ + "static/media/9.2cfbf654.webp";